import { b as base } from "../../../../chunks/server.js";
import "../../../../chunks/url.js";
import "@sveltejs/kit/internal/server";
import "../../../../chunks/root.js";
import { c as cookieOptions } from "../../../../chunks/oauth.js";
import { redirect } from "@sveltejs/kit";
const actions = {
  default: async ({ cookies, url }) => {
    cookies.delete("mongoku_session", cookieOptions(url));
    redirect(302, `${base}/auth/logout`);
  }
};
export {
  actions
};
